function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("3xe8M", function(module, exports) {
    $parcel$export(module.exports, "getGlobalErrorCount", ()=>$382b2867724b0e83$export$d06c0426664e7c08);
    $parcel$export(module.exports, "default", ()=>$382b2867724b0e83$export$2e2bcd8739ae039);
    var $cBeZP;
    let $382b2867724b0e83$var$shouldInitilizeGlobalErrorHandler = true;
    let $382b2867724b0e83$var$globalCount = 0;
    const $382b2867724b0e83$var$errors = [];
    let $382b2867724b0e83$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
        $382b2867724b0e83$var$errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    };
    const $382b2867724b0e83$export$ebe081a8c9bf8176 = (sinkFunc)=>{
        $382b2867724b0e83$var$push = sinkFunc;
        $382b2867724b0e83$var$errors.forEach((e)=>{
            sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
        });
        $382b2867724b0e83$var$errors.length = 0;
    };
    const $382b2867724b0e83$export$d06c0426664e7c08 = ()=>$382b2867724b0e83$var$globalCount;
    const $382b2867724b0e83$var$handleError = (e)=>{
        $382b2867724b0e83$var$globalCount++;
        if (e.error?.UFOhasCaught === undefined) try {
            if (e.error instanceof Error) $382b2867724b0e83$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
            else if (e.error) {
                const hint = JSON.stringify(e.error).slice(0, 50);
                $382b2867724b0e83$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
            } else if (e.message !== undefined) {
                const hint = e.message.slice(0, 50);
                $382b2867724b0e83$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
            }
            if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
        } catch (e) {}
    };
    const $382b2867724b0e83$var$handlePromiseRejection = (e)=>{
        $382b2867724b0e83$var$globalCount++;
        if (e.reason instanceof Error) $382b2867724b0e83$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
        else if (e.reason) try {
            const hint = JSON.stringify(e.reason).slice(0, 50);
            $382b2867724b0e83$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } catch (e) {}
    };
    const $382b2867724b0e83$var$setupUFOGlobalErrorHandler = ()=>{
        if ($382b2867724b0e83$var$shouldInitilizeGlobalErrorHandler) {
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'error',
                listener: (e)=>$382b2867724b0e83$var$handleError(e)
            });
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'unhandledrejection',
                listener: $382b2867724b0e83$var$handlePromiseRejection
            });
            $382b2867724b0e83$var$shouldInitilizeGlobalErrorHandler = false;
        }
    };
    var $382b2867724b0e83$export$2e2bcd8739ae039 = $382b2867724b0e83$var$setupUFOGlobalErrorHandler;
});
parcelRegister("kdrsV", function(module, exports) {
    $parcel$export(module.exports, "getCookie", ()=>$62cc03b4807c6a84$export$4be65e66cfa2648a);
    var $eYli8 = parcelRequire("eYli8");
    var $294ns;
    var $ipHwT;
    var $6rvxM;
    function $62cc03b4807c6a84$export$4be65e66cfa2648a(key) {
        if ((0, (0, parcelRequire("294ns")).fg)('platform_moonjelly_bsc_master_killswitch')) return key ? (0, ($parcel$interopDefault($eYli8))).get(key) : (0, ($parcel$interopDefault($eYli8))).get();
        try {
            (0, (0, parcelRequire("ipHwT")).sendPackageOperationalEvent)({
                action: 'usedGetCookie',
                attributes: {
                    cookieKey: key
                }
            });
            return key ? (0, ($parcel$interopDefault($eYli8))).get(key) : (0, ($parcel$interopDefault($eYli8))).get();
        } catch (e) {
            (0, (0, parcelRequire("6rvxM")).Logger).errorWithOperationalEvent({
                action: 'usedGetCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use get cookie. ${e.message || ''}`
            });
        }
    }
});
parcelRegister("ipHwT", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsClient", ()=>$af021e5f47c5b963$export$fde53e78fd93a54d);
    $parcel$export(module.exports, "sendPackageOperationalEvent", ()=>$af021e5f47c5b963$export$5bfe55348e7aebc1);
    $parcel$export(module.exports, "sendUIEvent", ()=>$af021e5f47c5b963$export$1aecf263098db667);
    $parcel$export(module.exports, "sendScreenEvent", ()=>$af021e5f47c5b963$export$22a3b1671f38a193);
    $parcel$export(module.exports, "sendTrackEvent", ()=>$af021e5f47c5b963$export$1ba525b8a711eaac);
    var $1o4Nl;
    var $bpIMA;
    var $kcbTK;
    var $6rvxM;
    var $9Kmiy;
    var $cH4lp;
    const $af021e5f47c5b963$var$getEnvironment = ()=>{
        const { hostname: hostname } = window.location;
        if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, (0, parcelRequire("bpIMA")).envType).STAGING;
        if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, (0, parcelRequire("bpIMA")).envType).DEV;
        return (0, (0, parcelRequire("bpIMA")).envType).PROD;
    };
    const $af021e5f47c5b963$export$78d7c0236b4fece9 = (path)=>{
        let subPath = '';
        if (!path) return subPath;
        const checkPath = (match)=>{
            return new RegExp(`^${match}(/|$)`).test(String(path));
        };
        if (checkPath('/wiki')) subPath = '/wiki';
        if (checkPath('/jira')) subPath = '/jira';
        if (checkPath('/compass')) subPath = '/compass';
        if (checkPath('/canvas')) subPath = '/canvas';
        if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
        return subPath;
    };
    const $af021e5f47c5b963$var$getProductFromDomain = (domain)=>{
        if (domain === 'https://trello.com') return 'trello';
        return null;
    };
    const $af021e5f47c5b963$export$fce3dd735e04d566 = ()=>{
        const { origin: origin, pathname: pathname } = window.location;
        const productPath = $af021e5f47c5b963$export$78d7c0236b4fece9(pathname);
        const domain = `${origin}${productPath}`;
        const product = $af021e5f47c5b963$var$getProductFromDomain(domain) || productPath.slice(1);
        return {
            domain: domain,
            product: product
        };
    };
    const $af021e5f47c5b963$var$decorateEventAttributes = (attributes)=>{
        const { domain: domain, product: product } = $af021e5f47c5b963$export$fce3dd735e04d566();
        return {
            packageName: (0, parcelRequire("9Kmiy")).packageName,
            packageVersion: (0, parcelRequire("9Kmiy")).packageVersion,
            domain: domain,
            product: (0, (0, parcelRequire("kcbTK")).getBscGlobalState)().product?.toLowerCase() ?? product,
            ...attributes && attributes
        };
    };
    const $af021e5f47c5b963$export$fde53e78fd93a54d = (()=>{
        let instance;
        return ()=>{
            try {
                if (!instance && (0, (0, parcelRequire("kcbTK")).getBscGlobalState)().analyticsEnabled) instance = new (0, (0, parcelRequire("1o4Nl")).default)({
                    env: $af021e5f47c5b963$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
            } catch (e) {
                (0, (0, parcelRequire("6rvxM")).Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
            }
            if (!(0, (0, parcelRequire("kcbTK")).getBscGlobalState)().analyticsEnabled) return undefined;
            return instance;
        };
    })();
    function $af021e5f47c5b963$export$5bfe55348e7aebc1(properties) {
        (0, (0, parcelRequire("cH4lp")).withAnalyticsEventSampling)(properties.action, ()=>$af021e5f47c5b963$export$fde53e78fd93a54d()?.sendOperationalEvent({
                source: 'package',
                actionSubject: 'package',
                action: properties.action,
                attributes: $af021e5f47c5b963$var$decorateEventAttributes(properties.attributes)
            }));
    }
    function $af021e5f47c5b963$export$1aecf263098db667(properties) {
        $af021e5f47c5b963$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $af021e5f47c5b963$var$decorateEventAttributes(properties.attributes)
        });
    }
    function $af021e5f47c5b963$export$22a3b1671f38a193(properties) {
        $af021e5f47c5b963$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $af021e5f47c5b963$var$decorateEventAttributes(properties.attributes)
        });
    }
    function $af021e5f47c5b963$export$1ba525b8a711eaac(properties) {
        $af021e5f47c5b963$export$fde53e78fd93a54d()?.sendTrackEvent({
            ...properties,
            attributes: $af021e5f47c5b963$var$decorateEventAttributes(properties.attributes)
        });
    }
});
parcelRegister("kcbTK", function(module, exports) {
    $parcel$export(module.exports, "getBscGlobalState", ()=>$6f0c02a7b15819e9$export$3b78a1ea01f5ec28);
    $parcel$export(module.exports, "initializeGlobalState", ()=>$6f0c02a7b15819e9$export$882c4530c58781d8);
    var $eYli8 = parcelRequire("eYli8");
    var $294ns;
    var $5mg3z;
    var $hnmWS;
    let $6f0c02a7b15819e9$var$localAnalyticsEnabled;
    let $6f0c02a7b15819e9$var$localProduct;
    let $6f0c02a7b15819e9$var$webStorageControlsEnabled;
    let $6f0c02a7b15819e9$var$localConsentModeEnabled;
    let $6f0c02a7b15819e9$var$packageDebugModeEnabled;
    let $6f0c02a7b15819e9$var$cookiesCacheLoader;
    let $6f0c02a7b15819e9$var$localStorageCacheLoader;
    let $6f0c02a7b15819e9$var$sessionStorageCacheLoader;
    let $6f0c02a7b15819e9$var$loadCache = async (storageType)=>{
        switch(storageType){
            case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).Cookies:
                return await $6f0c02a7b15819e9$var$cookiesCacheLoader?.loadStorageControlsData();
            case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).LocalStorage:
                return await $6f0c02a7b15819e9$var$localStorageCacheLoader?.loadStorageControlsData();
            case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).SessionStorage:
                return await $6f0c02a7b15819e9$var$sessionStorageCacheLoader?.loadStorageControlsData();
            default:
                return undefined;
        }
    };
    const $6f0c02a7b15819e9$export$3b78a1ea01f5ec28 = ()=>{
        if ($6f0c02a7b15819e9$var$localAnalyticsEnabled == null) $6f0c02a7b15819e9$var$localAnalyticsEnabled = true;
        $6f0c02a7b15819e9$var$localConsentModeEnabled = $6f0c02a7b15819e9$var$localConsentModeEnabled ?? false;
        return {
            analyticsEnabled: $6f0c02a7b15819e9$var$localAnalyticsEnabled,
            product: $6f0c02a7b15819e9$var$localProduct,
            webStorageEnabled: $6f0c02a7b15819e9$var$webStorageControlsEnabled,
            localConsentMode: $6f0c02a7b15819e9$var$localConsentModeEnabled,
            packageDebugMode: $6f0c02a7b15819e9$var$packageDebugModeEnabled,
            cookiesCacheLoader: $6f0c02a7b15819e9$var$cookiesCacheLoader,
            localStorageCacheLoader: $6f0c02a7b15819e9$var$localStorageCacheLoader,
            sessionStorageCacheLoader: $6f0c02a7b15819e9$var$sessionStorageCacheLoader,
            loadCache: $6f0c02a7b15819e9$var$loadCache
        };
    };
    const $6f0c02a7b15819e9$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'NONE', webStorageEnabled: webStorageEnabled = false, localConsentMode: localConsentMode = false } = {})=>{
        $6f0c02a7b15819e9$var$localAnalyticsEnabled = analyticsEnabled;
        $6f0c02a7b15819e9$var$localProduct = product;
        $6f0c02a7b15819e9$var$webStorageControlsEnabled = webStorageEnabled;
        $6f0c02a7b15819e9$var$localConsentModeEnabled = localConsentMode;
        $6f0c02a7b15819e9$var$cookiesCacheLoader = new (0, (0, parcelRequire("hnmWS")).CacheLoader)((0, (0, parcelRequire("5mg3z")).CategoryStorageType).Cookies);
        $6f0c02a7b15819e9$var$localStorageCacheLoader = new (0, (0, parcelRequire("hnmWS")).CacheLoader)((0, (0, parcelRequire("5mg3z")).CategoryStorageType).LocalStorage);
        $6f0c02a7b15819e9$var$sessionStorageCacheLoader = new (0, (0, parcelRequire("hnmWS")).CacheLoader)((0, (0, parcelRequire("5mg3z")).CategoryStorageType).SessionStorage);
        if ((0, (0, parcelRequire("294ns")).fg)('platform_moonjelly_bsc_debug_mode')) $6f0c02a7b15819e9$var$packageDebugModeEnabled = Boolean((0, ($parcel$interopDefault($eYli8))).get('atl-bsc-debug-mode'));
    };
    const $6f0c02a7b15819e9$export$f86e17381f699baf = ({ loadCache: overrideLoadCache })=>{
        if (overrideLoadCache) $6f0c02a7b15819e9$var$loadCache = overrideLoadCache;
    };
    const $6f0c02a7b15819e9$export$ac7c2edd09656c05 = ()=>{
        $6f0c02a7b15819e9$var$localAnalyticsEnabled = undefined;
        $6f0c02a7b15819e9$var$localProduct = undefined;
        $6f0c02a7b15819e9$var$webStorageControlsEnabled = undefined;
        $6f0c02a7b15819e9$var$localConsentModeEnabled = undefined;
        $6f0c02a7b15819e9$var$packageDebugModeEnabled = undefined;
        $6f0c02a7b15819e9$var$cookiesCacheLoader = undefined;
        $6f0c02a7b15819e9$var$localStorageCacheLoader = undefined;
        $6f0c02a7b15819e9$var$sessionStorageCacheLoader = undefined;
    };
});
parcelRegister("5mg3z", function(module, exports) {
    $parcel$export(module.exports, "PreferenceCategory", ()=>$e602ea4dbc5a9a98$export$ba064dbfe4bb66d7);
    $parcel$export(module.exports, "ConsentPreferenceV2", ()=>$e602ea4dbc5a9a98$export$cdef20bac194f235);
    $parcel$export(module.exports, "ContextualConsentProperty", ()=>$e602ea4dbc5a9a98$export$fac80ad19b60e313);
    $parcel$export(module.exports, "CachedKeysDataPropertyLegacy", ()=>$e602ea4dbc5a9a98$export$4fda8eb914d6791c);
    $parcel$export(module.exports, "PrefetchedPreferenceState", ()=>$e602ea4dbc5a9a98$export$5d6594a0bba4ab8a);
    $parcel$export(module.exports, "CategoryStorageType", ()=>$e602ea4dbc5a9a98$export$2506b012eb637f61);
    $parcel$export(module.exports, "Status", ()=>$e602ea4dbc5a9a98$export$96e9906d6d93a972);
    var $e602ea4dbc5a9a98$export$ba064dbfe4bb66d7;
    (function(PreferenceCategory) {
        PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
        PreferenceCategory["Functional"] = "FUNCTIONAL";
        PreferenceCategory["Marketing"] = "MARKETING";
        PreferenceCategory["Analytics"] = "ANALYTICS";
        PreferenceCategory["Unknown"] = "UNKNOWN";
    })($e602ea4dbc5a9a98$export$ba064dbfe4bb66d7 || ($e602ea4dbc5a9a98$export$ba064dbfe4bb66d7 = {}));
    var $e602ea4dbc5a9a98$export$cdef20bac194f235;
    (function(ConsentPreferenceV2) {
        ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
        ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
        ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
        ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    })($e602ea4dbc5a9a98$export$cdef20bac194f235 || ($e602ea4dbc5a9a98$export$cdef20bac194f235 = {}));
    var $e602ea4dbc5a9a98$export$fac80ad19b60e313;
    (function(ContextualConsentProperty) {
        ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
        ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
        ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    })($e602ea4dbc5a9a98$export$fac80ad19b60e313 || ($e602ea4dbc5a9a98$export$fac80ad19b60e313 = {}));
    var $e602ea4dbc5a9a98$export$4fda8eb914d6791c;
    (function(CachedKeysDataPropertyLegacy) {
        CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
        CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
        CachedKeysDataPropertyLegacy["Cookies"] = "keys";
        CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    })($e602ea4dbc5a9a98$export$4fda8eb914d6791c || ($e602ea4dbc5a9a98$export$4fda8eb914d6791c = {}));
    var $e602ea4dbc5a9a98$export$5d6594a0bba4ab8a;
    (function(PrefetchedPreferenceState) {
        PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    })($e602ea4dbc5a9a98$export$5d6594a0bba4ab8a || ($e602ea4dbc5a9a98$export$5d6594a0bba4ab8a = {}));
    var $e602ea4dbc5a9a98$export$2506b012eb637f61;
    (function(CategoryStorageType) {
        CategoryStorageType["Cookies"] = "Cookies";
        CategoryStorageType["LocalStorage"] = "LocalStorage";
        CategoryStorageType["SessionStorage"] = "SessionStorage";
    })($e602ea4dbc5a9a98$export$2506b012eb637f61 || ($e602ea4dbc5a9a98$export$2506b012eb637f61 = {}));
    var $e602ea4dbc5a9a98$export$96e9906d6d93a972;
    (function(Status) {
        Status["SUCCESS"] = "SUCCESS";
        Status["BLOCKED"] = "BLOCKED";
        Status["FAILED"] = "FAILED";
    })($e602ea4dbc5a9a98$export$96e9906d6d93a972 || ($e602ea4dbc5a9a98$export$96e9906d6d93a972 = {}));
    var $e602ea4dbc5a9a98$export$eefdbcf75990494a;
    (function(BSC_PACKAGE_KILLSWITCHES) {
        BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
        BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
        BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    })($e602ea4dbc5a9a98$export$eefdbcf75990494a || ($e602ea4dbc5a9a98$export$eefdbcf75990494a = {}));
});
parcelRegister("hnmWS", function(module, exports) {
    $parcel$export(module.exports, "CacheLoader", ()=>$c9adca1842f4b6e6$export$e479342c697b82a9);
    var $5mg3z;
    var $6rvxM;
    class $c9adca1842f4b6e6$export$e479342c697b82a9 {
        constructor(storageType){
            switch(storageType){
                case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).Cookies:
                    this.cacheUrl = (0, $1f70cf6e27ef4358$export$ab0619f627170401);
                    break;
                case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).LocalStorage:
                    this.cacheUrl = (0, $1f70cf6e27ef4358$export$38bed9fd9923fef3);
                    break;
                case (0, (0, parcelRequire("5mg3z")).CategoryStorageType).SessionStorage:
                    this.cacheUrl = (0, $1f70cf6e27ef4358$export$4f73a4b5fdb7ed6c);
                    break;
                default:
                    this.cacheUrl = (0, $1f70cf6e27ef4358$export$194c34963e6f0bc6);
            }
        }
        clearStorageControlsDataCache() {
            this.localResponseCache = undefined;
            this.localResponsePromiseCache = undefined;
            this.localResponseJsonPromiseCache = undefined;
        }
        async handleCategoriesResponse(responsePromise) {
            if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
            const response = await responsePromise;
            if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
            this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
            return this.localResponseJsonPromiseCache;
        }
        async loadStorageControlsData() {
            if (this.localResponseCache) return this.localResponseCache;
            else try {
                if (!this.localResponsePromiseCache) {
                    (0, (0, parcelRequire("6rvxM")).Logger).debug(`Loading cache ${this.cacheUrl}`);
                    this.localResponsePromiseCache = fetch(this.cacheUrl);
                }
                this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
                return this.localResponseCache;
            } catch (e) {
                (0, (0, parcelRequire("6rvxM")).Logger).errorWithOperationalEvent({
                    action: 'loadStorageControlsError',
                    message: e.message || ''
                });
                this.clearStorageControlsDataCache();
            }
        }
    }
});
parcelRegister("6rvxM", function(module, exports) {
    $parcel$export(module.exports, "Logger", ()=>$2299fdf69451efac$export$efa9a398d6368992);
    var $294ns;
    var $ipHwT;
    var $kcbTK;
    const $2299fdf69451efac$var$LOG_PREFIX = '[browser-storage-controls]';
    class $2299fdf69451efac$export$efa9a398d6368992 {
        static info(message, metadata) {
            console.log(`${$2299fdf69451efac$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
        static error(message, metadata) {
            console.error(`${$2299fdf69451efac$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
        static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
            try {
                (0, (0, parcelRequire("ipHwT")).sendPackageOperationalEvent)({
                    action: action,
                    attributes: {
                        error: message,
                        ...attributes
                    }
                });
            } catch (e) {
                this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
            }
            this.error(message, metadata ? JSON.stringify(metadata) : '');
        }
        static warn(message, metadata) {
            console.warn(`${$2299fdf69451efac$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
        static debug(message, metadata) {
            if ((0, (0, parcelRequire("kcbTK")).getBscGlobalState)().packageDebugMode && (0, (0, parcelRequire("294ns")).fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$2299fdf69451efac$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
        }
    }
});
const $1f70cf6e27ef4358$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $1f70cf6e27ef4358$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $1f70cf6e27ef4358$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $1f70cf6e27ef4358$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
parcelRegister("9Kmiy", function(module, exports) {
    $parcel$export(module.exports, "packageName", ()=>$22913bab0911caab$export$9345d7360ffe0722);
    $parcel$export(module.exports, "packageVersion", ()=>$22913bab0911caab$export$91546b032799aa40);
    var $6cAn5 = parcelRequire("6cAn5");
    const $22913bab0911caab$export$9345d7360ffe0722 = $6cAn5?.env._PACKAGE_NAME_ ?? '';
    const $22913bab0911caab$export$91546b032799aa40 = $6cAn5?.env._PACKAGE_VERSION_ ?? '';
});
parcelRegister("cH4lp", function(module, exports) {
    $parcel$export(module.exports, "withAnalyticsEventSampling", ()=>$d8cd192d7f5f1279$export$67b6e87f323cb6ad);
    var $294ns;
    var $5mg3z;
    var $kcbTK;
    var $iIJla;
    var $gKQFw;
    var $ciZGq;
    const $d8cd192d7f5f1279$export$1138592b3c099377 = {
        usedGetCookie: 100000,
        usedGetCookieError: 1,
        usedSetCookie: 1000,
        usedSetCookieError: 1,
        usedSetStrictlyNecessaryCookie: 10000,
        usedSetStrictlyNecessaryCookieError: 1,
        usedDeleteCookie: 10,
        usedDeleteCookieError: 1,
        usedCheckThirdParty: 100000,
        checkThirdPartyError: 1,
        usedDocumentCookie: 100,
        usedDocumentCookieError: 1,
        initializeControlsError: 1,
        loadStorageControlsError: 1,
        updatePreferencesError: 1,
        fetchConsentPreferencesError: 1,
        saveConsentPreferencesError: 1,
        usedAtlBrowserStorageGetItem: 100,
        usedAtlBrowserStorageGetItemError: 1,
        usedAtlBrowserStorageSetItem: 100,
        usedAtlBrowserStorageSetItemError: 1,
        usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
        usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
        usedCheckIfSetByPackageError: 1,
        renderConsentBannerError: 1,
        bannerAppearanceAfterDismissal: 1
    };
    const $d8cd192d7f5f1279$var$localOnlySamplingKeys = [
        'loadStorageControlsError'
    ];
    async function $d8cd192d7f5f1279$var$loadSamplingConfig() {
        if ((0, (0, parcelRequire("iIJla")).cache).cachedSamplingConfig) return (0, (0, parcelRequire("iIJla")).cache).cachedSamplingConfig;
        if ((0, (0, parcelRequire("gKQFw")).isSSR)()) return undefined;
        if ((0, (0, parcelRequire("294ns")).fg)('platform_moonjelly_bsc_new_caches')) {
            const { loadCache: loadCache } = (0, (0, parcelRequire("kcbTK")).getBscGlobalState)();
            const controlsData = await loadCache((0, (0, parcelRequire("5mg3z")).CategoryStorageType).Cookies);
            const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
            (0, (0, parcelRequire("iIJla")).cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
            return analyticsSamplingRatioConfigs;
        } else {
            const controlsData = await (0, (0, parcelRequire("ciZGq")).loadStorageControlsData)();
            const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
            (0, (0, parcelRequire("iIJla")).cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
            return analyticsSamplingRatioConfigs;
        }
    }
    async function $d8cd192d7f5f1279$export$b286f5e8716d11ad(analyticsEventKey) {
        if ($d8cd192d7f5f1279$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $d8cd192d7f5f1279$export$1138592b3c099377[analyticsEventKey];
        const remoteSamplingConfig = await $d8cd192d7f5f1279$var$loadSamplingConfig();
        const samplingConfig = remoteSamplingConfig ?? $d8cd192d7f5f1279$export$1138592b3c099377;
        const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $d8cd192d7f5f1279$export$1138592b3c099377[analyticsEventKey];
        return samplingRatio;
    }
    function $d8cd192d7f5f1279$export$dc2f0946255b3f89(samplingRatio, cb) {
        const shouldRun = !Math.floor(Math.random() * samplingRatio);
        shouldRun && cb();
    }
    async function $d8cd192d7f5f1279$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
        const ratio = await $d8cd192d7f5f1279$export$b286f5e8716d11ad(analyticsEventKey);
        $d8cd192d7f5f1279$export$dc2f0946255b3f89(ratio, cb);
    }
});
parcelRegister("iIJla", function(module, exports) {
    $parcel$export(module.exports, "cache", ()=>$7db4ef350c730595$export$69a3209f1a06c04d);
    var $8wpuJ;
    const $7db4ef350c730595$export$69a3209f1a06c04d = new (0, (0, parcelRequire("8wpuJ")).CachedSamplingConfig)();
});
parcelRegister("8wpuJ", function(module, exports) {
    $parcel$export(module.exports, "CachedSamplingConfig", ()=>$b0bb7bf7f2d8ee55$export$b886edaf6623554a);
    class $b0bb7bf7f2d8ee55$export$b886edaf6623554a {
        get cachedSamplingConfig() {
            return this.cache;
        }
        set cachedSamplingConfig(value) {
            this.cache = value;
        }
    }
});
parcelRegister("gKQFw", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$f65eedb0b1d1881e$export$48d7c418edadb60c);
    var $1o4Nl;
    var $294ns;
    var $6rvxM;
    const $f65eedb0b1d1881e$export$48d7c418edadb60c = ()=>{
        const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
        const isMissingBooleanFF = !(0, (0, parcelRequire("294ns")).fg);
        const isMissingAnalyticsWebClient = !Boolean((0, (0, parcelRequire("1o4Nl")).default));
        if (isMissingNecessaryBrowserUtils) (0, (0, parcelRequire("6rvxM")).Logger).warn('Browser context is not available.');
        if (isMissingBooleanFF) (0, (0, parcelRequire("6rvxM")).Logger).warn('Platform Feature Flag library is not available');
        if (!(0, (0, parcelRequire("1o4Nl")).default)) (0, (0, parcelRequire("6rvxM")).Logger).warn('analytics-web-client is not available');
        if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
        else return false;
    };
});
parcelRegister("ciZGq", function(module, exports) {
    $parcel$export(module.exports, "loadStorageControlsData", ()=>$04d97225ec539b5a$export$4dbb842f063ffea4);
    var $6rvxM;
    const $04d97225ec539b5a$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
    let $04d97225ec539b5a$var$localResponseCache;
    let $04d97225ec539b5a$var$localResponsePromiseCache;
    let $04d97225ec539b5a$var$localResponseJsonPromiseCache;
    const $04d97225ec539b5a$export$19bc72f5ccd901a6 = ()=>{
        $04d97225ec539b5a$var$localResponseCache = undefined;
        $04d97225ec539b5a$var$localResponsePromiseCache = undefined;
        $04d97225ec539b5a$var$localResponseJsonPromiseCache = undefined;
    };
    const $04d97225ec539b5a$var$handleCategoriesResponse = async (responsePromise)=>{
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        $04d97225ec539b5a$var$localResponseJsonPromiseCache = $04d97225ec539b5a$var$localResponseJsonPromiseCache || response?.json();
        return $04d97225ec539b5a$var$localResponseJsonPromiseCache;
    };
    const $04d97225ec539b5a$export$4dbb842f063ffea4 = async ()=>{
        if ($04d97225ec539b5a$var$localResponseCache) return $04d97225ec539b5a$var$localResponseCache;
        else try {
            if (!$04d97225ec539b5a$var$localResponsePromiseCache) $04d97225ec539b5a$var$localResponsePromiseCache = fetch($04d97225ec539b5a$export$ab0619f627170401);
            $04d97225ec539b5a$var$localResponseCache = await $04d97225ec539b5a$var$handleCategoriesResponse($04d97225ec539b5a$var$localResponsePromiseCache);
            return $04d97225ec539b5a$var$localResponseCache;
        } catch (e) {
            (0, (0, parcelRequire("6rvxM")).Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            $04d97225ec539b5a$export$19bc72f5ccd901a6();
        }
    };
});
parcelRegister("80cnJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6be54a6cb997ef48$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useInteractionContext", ()=>$6be54a6cb997ef48$export$11bcb6e9af2aca35);
    var $5uXOq = parcelRequire("5uXOq");
    var $k1Pt3;
    var $6be54a6cb997ef48$export$2e2bcd8739ae039 = (0, (0, parcelRequire("k1Pt3")).default);
    function $6be54a6cb997ef48$export$11bcb6e9af2aca35() {
        return (0, $5uXOq.useContext)((0, (0, parcelRequire("k1Pt3")).default));
    }
});
parcelRegister("2T3fn", function(module, exports) {
    $parcel$export(module.exports, "ufologger", ()=>$d884fb01e6c88079$export$4ab84f6f04f6566d);
    $parcel$export(module.exports, "ufolog", ()=>$d884fb01e6c88079$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$d884fb01e6c88079$export$d53d07b6034c4560);
    class $d884fb01e6c88079$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($d884fb01e6c88079$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($d884fb01e6c88079$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $d884fb01e6c88079$export$4ab84f6f04f6566d = new $d884fb01e6c88079$var$UFOLogger();
    const $d884fb01e6c88079$export$b4958caff08a0960 = (...args)=>{
        $d884fb01e6c88079$export$4ab84f6f04f6566d.log(...args);
    };
    const $d884fb01e6c88079$export$d53d07b6034c4560 = (...args)=>{
        $d884fb01e6c88079$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("cL10T", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$8349c9c6620668f7$export$15e172712955e18f);
    const $8349c9c6620668f7$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("lRZ3b", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$6c48e42f66721af8$export$6123a44dc2384540);
    $parcel$export(module.exports, "setGlobalEventStream", ()=>$6c48e42f66721af8$export$c1522520b417b066);
    $parcel$export(module.exports, "subscribeEvent", ()=>$6c48e42f66721af8$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$6c48e42f66721af8$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$6c48e42f66721af8$export$7c957416596ca127);
    var $2T3fn;
    var $dYd4e;
    const $6c48e42f66721af8$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $6c48e42f66721af8$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $6c48e42f66721af8$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $6c48e42f66721af8$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("2T3fn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $6c48e42f66721af8$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $6c48e42f66721af8$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $6c48e42f66721af8$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("dYd4e", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$84b2ae5d11a16ab7$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$84b2ae5d11a16ab7$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$84b2ae5d11a16ab7$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$84b2ae5d11a16ab7$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$84b2ae5d11a16ab7$export$837e0f79a8056912);
    var $84b2ae5d11a16ab7$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($84b2ae5d11a16ab7$export$96253c35c37cf96b || ($84b2ae5d11a16ab7$export$96253c35c37cf96b = {}));
    var $84b2ae5d11a16ab7$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($84b2ae5d11a16ab7$export$a12c67b37a306b13 || ($84b2ae5d11a16ab7$export$a12c67b37a306b13 = {}));
    var $84b2ae5d11a16ab7$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($84b2ae5d11a16ab7$export$66b33c055cbb625e || ($84b2ae5d11a16ab7$export$66b33c055cbb625e = {}));
    var $84b2ae5d11a16ab7$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($84b2ae5d11a16ab7$export$3ce489cbe02dc21b || ($84b2ae5d11a16ab7$export$3ce489cbe02dc21b = {}));
    var $84b2ae5d11a16ab7$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($84b2ae5d11a16ab7$export$341b330828bd3906 || ($84b2ae5d11a16ab7$export$341b330828bd3906 = {}));
    var $84b2ae5d11a16ab7$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($84b2ae5d11a16ab7$export$b9b20160f581e4f8 || ($84b2ae5d11a16ab7$export$b9b20160f581e4f8 = {}));
    const $84b2ae5d11a16ab7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $84b2ae5d11a16ab7$export$9f2bf58999404c75 = 'fmp';
    const $84b2ae5d11a16ab7$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("5UKnV", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$ca09a2cb8cae4c1c$export$13e680397ec8f3eb);
    var $cL10T;
    class $ca09a2cb8cae4c1c$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("cL10T")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $ca09a2cb8cae4c1c$export$13e680397ec8f3eb = new $ca09a2cb8cae4c1c$var$VisibilityChangeObserver();
});
parcelRegister("hNAhd", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$96b5879cd6e25b42$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$96b5879cd6e25b42$export$cc26007c03242fff);
    var $96b5879cd6e25b42$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($96b5879cd6e25b42$export$994164cf3ae1cc9a || ($96b5879cd6e25b42$export$994164cf3ae1cc9a = {}));
    var $96b5879cd6e25b42$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($96b5879cd6e25b42$export$cc26007c03242fff || ($96b5879cd6e25b42$export$cc26007c03242fff = {}));
});
parcelRegister("epSI1", function(module, exports) {
    $parcel$export(module.exports, "payloadPublisher", ()=>$67bd4afbc1eb9f8a$export$edb879ae55bb9be3);
    var $hNAhd;
    var $5UKnV;
    var $lRZ3b;
    var $2T3fn;
    var $dYd4e;
    var $69agQ;
    var $4vUna;
    var $9GiAH;
    var $dS1TE;
    var $8TkSE;
    var $2psna;
    var $ilFjQ;
    var $cUX8Z;
    var $esDQp;
    var $b1Utc;
    var $8SgNH;
    var $gZjV8;
    var $bIXdx;
    var $7drP3;
    var $9FL2N;
    var $ljQ68;
    var $6f44G;
    const $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE = 'unknown';
    const $67bd4afbc1eb9f8a$var$DEFAULT_PAYLOAD_DATA = {
        schemaVersion: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE,
        id: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE,
        uuid: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE,
        state: {
            id: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE
        },
        result: {
            startTime: 0,
            duration: 0,
            success: false
        },
        type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Experience,
        category: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE,
        performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).Custom,
        metadata: {},
        explicitTimings: {},
        metrics: {
            startTime: 0,
            endTime: 0,
            marks: []
        },
        platform: null,
        children: [],
        pageVisibleState: (0, (0, parcelRequire("dYd4e")).PageVisibleState).MIXED,
        isSSROutputAsFMP: false,
        timings: [],
        featureFlags: []
    };
    class $67bd4afbc1eb9f8a$var$Publisher {
        publish(data) {
            const payloadStart = (0, (0, parcelRequire("6f44G")).getPerformanceObject)()?.now() || 0;
            const experienceKey = this.getExperienceKey(data);
            if (!this.allowlist(experienceKey, data)) {
                (0, (0, parcelRequire("2T3fn")).ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
                return;
            }
            const supportedData = {
                ...$67bd4afbc1eb9f8a$var$DEFAULT_PAYLOAD_DATA,
                ...data
            };
            const payload = {
                actionSubject: 'experience',
                action: 'measured',
                source: 'measured',
                tags: [
                    'observability'
                ],
                attributes: {
                    properties: {
                        'event:source': {
                            name: 'ufo/web',
                            version: supportedData.schemaVersion
                        },
                        'event:schema': (0, $e4daf622367ec357$export$93809551debf385f) || $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE,
                        'event:product': this.product,
                        'event:region': this.region,
                        'event:hostname': this.hostname,
                        'event:route': this.route.getRoute(),
                        ...(0, (0, parcelRequire("cUX8Z")).eventBrowserPlugin)(),
                        ...(0, (0, parcelRequire("esDQp")).eventCpusPlugin)(),
                        ...(0, (0, parcelRequire("8SgNH")).eventMemoryPlugin)(),
                        ...(0, (0, parcelRequire("gZjV8")).eventNetworkPlugin)(),
                        ...(0, (0, parcelRequire("2psna")).appFramework)(this.app),
                        ...(0, (0, parcelRequire("ilFjQ")).appVersion)(this.app),
                        'experience:name': supportedData.id,
                        'experience:key': experienceKey,
                        'experience:status': supportedData.state.id,
                        'experience:duration': supportedData.result.duration,
                        ...supportedData.result.startTime !== null ? {
                            'experience:startTime': supportedData.result.startTime
                        } : null,
                        ...supportedData.uuid ? {
                            'experience:spanId': supportedData.uuid
                        } : null,
                        ...this.tenantType !== (0, (0, parcelRequire("69agQ")).TenantType).RealUser ? {
                            'event:tenantType': this.tenantType
                        } : null,
                        ...this.mapMetadataToPayload(supportedData.metadata),
                        ...this.extractPageLoadData(supportedData),
                        ...(0, (0, parcelRequire("dS1TE")).pageVisibleState)(supportedData),
                        ...(0, (0, parcelRequire("ljQ68")).isInitialPageLoad)(supportedData) && (0, (0, parcelRequire("7drP3")).ssrSuccess)(this.ssr),
                        ...(0, (0, parcelRequire("ljQ68")).isInitialPageLoad)(supportedData) && (0, (0, parcelRequire("bIXdx")).ssrFeatureFlags)(this.ssr),
                        ...this.featureFlagClient && (0, (0, parcelRequire("b1Utc")).featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                    },
                    performance: this.getPerformanceMetrics(supportedData),
                    task: supportedData.id
                }
            };
            const payloadEnd = (0, (0, parcelRequire("6f44G")).getPerformanceObject)()?.now() || 0;
            payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
            if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
            else this.buffer.push(payload);
            (0, (0, parcelRequire("2T3fn")).ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
        }
        setGlobalEventStream() {
            if (!((0, (0, parcelRequire("lRZ3b")).getGlobalEventStream)() instanceof (0, (0, parcelRequire("4vUna")).UFOGlobalEventStream))) {
                const eventStream = new (0, (0, parcelRequire("4vUna")).UFOGlobalEventStream)();
                eventStream.push({
                    type: (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).SUBSCRIBE,
                    payload: {
                        experienceId: '__SUBSCRIBE_ALL__',
                        callback: this.publish.bind(this)
                    }
                });
                (0, (0, parcelRequire("lRZ3b")).setGlobalEventStream)(eventStream);
            }
        }
        setRoute(newRoute) {
            this.route.setRoute(newRoute);
        }
        setup(config) {
            (0, (0, parcelRequire("5UKnV")).visibilityChangeObserver).start();
            (0, (0, parcelRequire("8TkSE")).resourceTimingBuffer).start();
            if (!this.product) this.product = config.product || '';
            if (config.allowlist) this.allowlist = config.allowlist;
            if (config.tenantType) this.tenantType = config.tenantType;
            if (config.hostname) this.hostname = config.hostname;
            if (config.region) this.region = config.region;
            if (config.app) this.app = config.app;
            if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
            if (config.featureFlags) this.featureFlags = config.featureFlags;
            if (config.ssr) this.ssr = config.ssr;
            if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
            if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
            if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
            if (config.plugins) this.plugins = config.plugins;
            this.setGlobalEventStream();
            if (!this.gasv3) {
                this.gasv3 = config.gasv3;
                this.buffer.forEach(this.gasv3.sendOperationalEvent);
            }
        }
        mapMetadataToPayload(metadata) {
            const payload = {};
            Object.entries(metadata).forEach(([key, value])=>{
                if (value !== undefined) payload[`custom:${key}`] = value;
            });
            return payload;
        }
        extractPageLoadData(data) {
            if ('initial' in data) return {
                'experience:pageLoadType': data.initial ? 'initial' : 'transition'
            };
            return {};
        }
        getPrefix(data) {
            if (data.platform !== null) return 'platform';
            return this.product;
        }
        getExperienceKey(data) {
            const keyParts = [
                this.getPrefix(data),
                'fe',
                data.type
            ];
            if (data.platform) keyParts.push(data.platform.component);
            keyParts.push(data.id);
            return keyParts.join('.');
        }
        getExperiencePerformanceKey(data) {
            const keyParts = [
                this.getPrefix(data),
                'fe',
                data.performanceType
            ];
            if (data.platform) keyParts.push(data.platform.component);
            keyParts.push(data.id);
            return keyParts.join('.');
        }
        getExperiencePerformanceType(data) {
            return data.performanceType;
        }
        getPerformanceMetrics(data) {
            return {
                'event:key': this.getExperiencePerformanceKey(data),
                'event:type': this.getExperiencePerformanceType(data),
                ...(0, (0, parcelRequire("9GiAH")).getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
                ...this.getPluginsMetrics(data)
            };
        }
        constructor(){
            this.gasv3 = null;
            this.product = '';
            this.region = $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE;
            this.hostname = (0, (0, parcelRequire("6f44G")).getWindowObject)()?.location?.hostname || '';
            this.tenantType = (0, (0, parcelRequire("69agQ")).TenantType).RealUser;
            this.app = {
                version: {
                    web: $67bd4afbc1eb9f8a$var$UNKNOWN_VALUE
                }
            };
            this.performanceConfig = {};
            this.buffer = [];
            this.featureFlagClient = null;
            this.featureFlags = [];
            this.ssr = null;
            this.resourceTimings = null;
            this.bundleEvalTimings = null;
            this.route = (0, (0, parcelRequire("9FL2N")).Route);
            this.plugins = null;
            this.allowlist = ()=>true;
            this.getPluginsMetrics = (data)=>{
                const result = {};
                if (this.plugins) this.plugins.forEach((plugin)=>{
                    const pluginOutput = plugin({
                        ...data
                    });
                    if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                    Object.entries(pluginOutput).forEach(([key, value])=>{
                        result[`${this.product}:${key}`] = value;
                    });
                });
                return result;
            };
        }
    }
    const $67bd4afbc1eb9f8a$export$edb879ae55bb9be3 = new $67bd4afbc1eb9f8a$var$Publisher();
});
const $e4daf622367ec357$export$93809551debf385f = '0.1.7';
parcelRegister("69agQ", function(module, exports) {
    $parcel$export(module.exports, "TenantType", ()=>$ac48a68a886828e3$export$92a757ac1398962f);
    var $ac48a68a886828e3$export$92a757ac1398962f;
    (function(TenantType) {
        TenantType["RealUser"] = "real-user";
        TenantType["Synthetic"] = "synthetic";
    })($ac48a68a886828e3$export$92a757ac1398962f || ($ac48a68a886828e3$export$92a757ac1398962f = {}));
});
parcelRegister("4vUna", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStream", ()=>$a442b50261ccdfcf$export$faf4c91b80fc830e);
    var $2T3fn;
    var $dYd4e;
    class $a442b50261ccdfcf$export$faf4c91b80fc830e {
        push(event) {
            (0, (0, parcelRequire("2T3fn")).ufolog)('EVENT STREAM push', event.type, event.payload);
            if (event.type === (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
            if (event.type === (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
            if (event.type === (0, (0, parcelRequire("dYd4e")).UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
        }
        publish(eventPayload) {
            if (this.subscribers[0, (0, parcelRequire("dYd4e")).SUBSCRIBE_ALL]) this.subscribers[0, (0, parcelRequire("dYd4e")).SUBSCRIBE_ALL].forEach((fn)=>{
                fn(eventPayload);
            });
            this.subscribers[eventPayload.id]?.forEach((fn)=>{
                fn(eventPayload);
            });
        }
        subscribe(experienceId, fn) {
            (0, (0, parcelRequire("2T3fn")).ufolog)('EVENT STREAM subscribe', experienceId);
            if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
            this.subscribers[experienceId].push(fn);
        }
        unsubscribe(experienceId, fn) {
            const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
            if (index !== -1) this.subscribers[experienceId].splice(index, 1);
        }
        constructor(){
            this.__buffer_only__ = false;
            this.subscribers = {};
        }
    }
});
parcelRegister("9GiAH", function(module, exports) {
    $parcel$export(module.exports, "getPerformancePayload", ()=>$140f297fd9a583bd$export$738d24377baf6a5e);
    var $hNAhd;
    var $dYd4e;
    var $ljQ68;
    var $e08lp;
    var $gync5;
    var $iJdtJ;
    var $5Lly5;
    const $140f297fd9a583bd$var$LoadMetricKeys = {
        tti: 'metric:tti',
        fmp: 'metric:fmp',
        ttiHistograms: 'metric:tti:histogramBuckets',
        fmpHistograms: 'metric:fmp:histogramBuckets'
    };
    const $140f297fd9a583bd$var$InlineResultMetricKeys = {
        result: 'metric:result',
        response: 'metric:response',
        resultHistograms: 'metric:result:histogramBuckets',
        responseHistograms: 'metric:response:histogramBuckets'
    };
    const $140f297fd9a583bd$var$CustomMetricKeys = {
        duration: 'metric:duration',
        durationHistograms: 'metric:duration:histogramBuckets'
    };
    const $140f297fd9a583bd$var$getHistogram = (data, performanceConfig, isInitial)=>{
        let histogram = {};
        if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
        else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
        if (histogram) {
            const histograms = histogram[data.performanceType];
            switch(data.performanceType){
                case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageLoad:
                case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageSegmentLoad:
                    const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                    return histograms ? {
                        [$140f297fd9a583bd$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                        [$140f297fd9a583bd$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                    } : {};
                case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).InlineResult:
                    return histograms ? {
                        [$140f297fd9a583bd$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                        [$140f297fd9a583bd$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                    } : {};
                case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).Custom:
                    return histograms ? {
                        [$140f297fd9a583bd$var$CustomMetricKeys.durationHistograms]: histograms.duration
                    } : {};
            }
        }
    };
    const $140f297fd9a583bd$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("dYd4e")).FMP_MARK))?.time || (0, (0, parcelRequire("ljQ68")).isInitialPageLoad)(data) && ssr?.getDoneMark();
        const tti = data.metrics.endTime - data.metrics.startTime;
        const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
        return {
            [$140f297fd9a583bd$var$LoadMetricKeys.tti]: Math.round(tti),
            [$140f297fd9a583bd$var$LoadMetricKeys.fmp]: Math.round(fmp),
            ...$140f297fd9a583bd$var$getHistogram(data, performanceConfig)
        };
    };
    const $140f297fd9a583bd$export$47f0208fd62dffce = (data, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, (0, parcelRequire("dYd4e")).INLINE_RESPONSE_MARK));
        const result = data.metrics.endTime - data.metrics.startTime;
        const response = responseMark ? responseMark.time - data.metrics.startTime : result;
        return {
            [$140f297fd9a583bd$var$InlineResultMetricKeys.result]: Math.round(result),
            [$140f297fd9a583bd$var$InlineResultMetricKeys.response]: Math.round(response),
            ...$140f297fd9a583bd$var$getHistogram(data, performanceConfig)
        };
    };
    const $140f297fd9a583bd$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
        if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
        const duration = data.metrics.endTime - data.metrics.startTime;
        return {
            [$140f297fd9a583bd$var$CustomMetricKeys.duration]: Math.round(duration),
            ...$140f297fd9a583bd$var$getHistogram(data, performanceConfig)
        };
    };
    const $140f297fd9a583bd$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
        switch(data.performanceType){
            case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageLoad:
            case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageSegmentLoad:
                return $140f297fd9a583bd$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
            case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).InlineResult:
                return $140f297fd9a583bd$export$47f0208fd62dffce(data, performanceConfig);
            case (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).Custom:
                return $140f297fd9a583bd$export$c25c1b3ff2ce92cf(data, performanceConfig);
        }
    };
    const $140f297fd9a583bd$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
        return {
            ...$140f297fd9a583bd$var$getPerformanceMetrics(data, ssr, performanceConfig),
            ...(0, (0, parcelRequire("5Lly5")).resourceTimings)(data, resourceConfig),
            ...(0, (0, parcelRequire("iJdtJ")).bundleEvalTimings)(data, bundleEvalConfig),
            ...(0, (0, parcelRequire("gync5")).appTimings)(data, ssr),
            ...(0, (0, parcelRequire("ljQ68")).isInitialPageLoad)(data) ? (0, (0, parcelRequire("e08lp")).navigationMetrics)() : null
        };
    };
});
parcelRegister("ljQ68", function(module, exports) {
    $parcel$export(module.exports, "isInitialPageLoad", ()=>$50d2373720631ab6$export$7167d96e9881d500);
    var $hNAhd;
    const $50d2373720631ab6$export$7167d96e9881d500 = (data)=>{
        return data.performanceType === (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageLoad && data.initial === true;
    };
});
parcelRegister("e08lp", function(module, exports) {
    $parcel$export(module.exports, "navigationMetrics", ()=>$c0c0072f5185ce5e$export$b88d990436be0f8a);
    const $c0c0072f5185ce5e$export$b88d990436be0f8a = ()=>{
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        const metrics = {
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart)
        };
        return {
            'metrics:navigation': metrics
        };
    };
});
parcelRegister("gync5", function(module, exports) {
    $parcel$export(module.exports, "appTimings", ()=>$7c7f3b47c61798e1$export$e952f50a4f2d02da);
    var $hNAhd;
    var $ljQ68;
    var $5fToz;
    var $lRnnn;
    const $7c7f3b47c61798e1$export$e952f50a4f2d02da = (data, ssrConfig)=>{
        const explicitTimings = data.performanceType === (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
        const timings = (0, (0, parcelRequire("5fToz")).customTimings)(data);
        const ssr = (0, (0, parcelRequire("ljQ68")).isInitialPageLoad)(data) ? (0, (0, parcelRequire("lRnnn")).ssrTimings)(ssrConfig) : null;
        const timingsApp = (explicitTimings || timings || ssr) && {
            ...explicitTimings,
            ...timings,
            ...ssr
        };
        if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
        return {
            'timings:app': timingsApp
        };
    };
});
parcelRegister("5fToz", function(module, exports) {
    $parcel$export(module.exports, "customTimings", ()=>$c3a827f8887704c0$export$6126f85083a72c6e);
    const $c3a827f8887704c0$var$retrieveTimings = (data)=>{
        const configTimings = data.timings || [];
        const timings = configTimings.reduce((entries, timing)=>{
            const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
            if (timing.startMark && !startMark) return entries;
            const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
            if (timing.endMark && !endMark) return entries;
            if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
            const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
            const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
            entries[`${timing.key}`] = {
                startTime: startTime,
                duration: duration
            };
            return entries;
        }, {});
        return timings;
    };
    const $c3a827f8887704c0$export$6126f85083a72c6e = (data)=>{
        if (!data.timings) return null;
        const timings = $c3a827f8887704c0$var$retrieveTimings(data);
        if (Object.keys(timings).length === 0) return null;
        return timings;
    };
});
parcelRegister("lRnnn", function(module, exports) {
    $parcel$export(module.exports, "ssrTimings", ()=>$cb8d7f4221445485$export$130f411261a599c5);
    const $cb8d7f4221445485$var$filterEntry = (entry)=>{
        return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    };
    const $cb8d7f4221445485$var$mapEntry = (entry)=>{
        return {
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        };
    };
    const $cb8d7f4221445485$var$SSR_PREFIX = 'ssr';
    const $cb8d7f4221445485$var$mapKey = (key)=>{
        if (key === 'total') return $cb8d7f4221445485$var$SSR_PREFIX;
        return `${$cb8d7f4221445485$var$SSR_PREFIX}${0, $f01628a1f4fa1901$export$b98e411ae80c806f}${key}`;
    };
    const $cb8d7f4221445485$export$130f411261a599c5 = (ssr)=>{
        if (!ssr?.getTimings) return null;
        const timings = ssr.getTimings();
        if (!timings) return null;
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($cb8d7f4221445485$var$filterEntry(entry[1])) acc[$cb8d7f4221445485$var$mapKey(entry[0])] = $cb8d7f4221445485$var$mapEntry(entry[1]);
            return acc;
        }, {});
        if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
        return ssrTimings;
    };
});
const $f01628a1f4fa1901$export$b98e411ae80c806f = '/';
parcelRegister("iJdtJ", function(module, exports) {
    $parcel$export(module.exports, "bundleEvalTimings", ()=>$81c2acad3a933efd$export$1a2bb347935fc536);
    var $6f44G;
    const $81c2acad3a933efd$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, (0, parcelRequire("6f44G")).getPerformanceObject)() || undefined)=>{
        if (!bundleEvalTimings) return null;
        const started = {};
        const timings = {};
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = bundleEvalTimings.mapPerformanceMark(mark.name);
            if (!result || data.result.startTime === null) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= data.result.startTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: Math.round(started[name].startTime - data.result.startTime),
                    duration: Math.round(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
            const result = bundleEvalTimings.additionalTimings(data.result.startTime);
            if (result) Object.entries(result).forEach(([key, value])=>{
                timings[key] = value;
            });
        }
        if (Object.keys(timings).length === 0) return null;
        return {
            'timings:bundleEval': timings
        };
    };
});
parcelRegister("6f44G", function(module, exports) {
    $parcel$export(module.exports, "getWindowObject", ()=>$da0c8eeb4ddadb3e$export$9aa44f85591248d9);
    $parcel$export(module.exports, "getPerformanceObject", ()=>$da0c8eeb4ddadb3e$export$8cd0c777b0eb66a0);
    $parcel$export(module.exports, "getPerformanceObserverObject", ()=>$da0c8eeb4ddadb3e$export$74560fd4e61fd440);
    const $da0c8eeb4ddadb3e$export$9aa44f85591248d9 = ()=>{
        return typeof window !== 'undefined' && !!window ? window : undefined;
    };
    const $da0c8eeb4ddadb3e$export$8cd0c777b0eb66a0 = ()=>{
        const { performance: performance } = $da0c8eeb4ddadb3e$export$9aa44f85591248d9() || {};
        return performance;
    };
    const $da0c8eeb4ddadb3e$export$74560fd4e61fd440 = ()=>{
        const { PerformanceObserver: PerformanceObserver } = $da0c8eeb4ddadb3e$export$9aa44f85591248d9() || {};
        return PerformanceObserver;
    };
});
parcelRegister("5Lly5", function(module, exports) {
    $parcel$export(module.exports, "resourceTimings", ()=>$afe2468bddae52b1$export$81a7d52441a06b50);
    var $6f44G;
    var $8TkSE;
    const $afe2468bddae52b1$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $afe2468bddae52b1$var$resourceTypes = [
        'fetch',
        'xmlhttprequest'
    ];
    const $afe2468bddae52b1$var$CACHE_NETWORK = 'network';
    const $afe2468bddae52b1$var$CACHE_MEMORY = 'memory';
    const $afe2468bddae52b1$var$CACHE_DISK = 'disk';
    const $afe2468bddae52b1$var$calculateTransferType = (type, duration, size)=>{
        if (!$afe2468bddae52b1$var$cacheableTypes.includes(type)) return $afe2468bddae52b1$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $afe2468bddae52b1$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $afe2468bddae52b1$var$CACHE_DISK;
        if (size === undefined) return null;
        return $afe2468bddae52b1$var$CACHE_NETWORK;
    };
    const $afe2468bddae52b1$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
        return !$afe2468bddae52b1$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, (0, parcelRequire("6f44G")).getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
    };
    const $afe2468bddae52b1$var$getReportedInitiatorTypes = (xhrEnabled)=>{
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    };
    const $afe2468bddae52b1$var$evaluateAccessToResourceTimings = (_url, entry)=>{
        return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
    };
    const $afe2468bddae52b1$var$getSizeObject = (size)=>size !== undefined ? {
            size: size
        } : null;
    const $afe2468bddae52b1$var$getNetworkData = (item, eventStart, hasTimingHeaders = $afe2468bddae52b1$var$evaluateAccessToResourceTimings)=>{
        const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
        const ttfb = Math.round(responseStart - eventStart);
        if (!$afe2468bddae52b1$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
        if ($afe2468bddae52b1$var$cacheableTypes.includes(initiatorType)) {
            const transferType = $afe2468bddae52b1$var$calculateTransferType(initiatorType, duration, transferSize);
            if (!transferType) return {
                ttfb: ttfb,
                ...$afe2468bddae52b1$var$getSizeObject(transferSize)
            };
            if (transferType !== $afe2468bddae52b1$var$CACHE_NETWORK) return {
                transferType: transferType
            };
            return {
                ttfb: ttfb,
                transferType: transferType,
                ...$afe2468bddae52b1$var$getSizeObject(transferSize)
            };
        }
        return {
            ttfb: ttfb,
            ...$afe2468bddae52b1$var$getSizeObject(transferSize)
        };
    };
    const $afe2468bddae52b1$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, (0, parcelRequire("6f44G")).getPerformanceObject)() || undefined)=>{
        if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
        const resources = (0, (0, parcelRequire("8TkSE")).getResourceTimings)(data.result.startTime, performance);
        if (!resources?.length) return null;
        const resourceTiming = {};
        const { xhrFilter: xhrFilter } = resourceTimings;
        const reportedInitiatorTypes = $afe2468bddae52b1$var$getReportedInitiatorTypes(!!xhrFilter);
        resources.forEach((item)=>{
            if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
            const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
            if (!name || data.result.startTime === null) return;
            if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
            const url = $afe2468bddae52b1$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
            if (!url || resourceTiming[url]) return;
            resourceTiming[url] = {
                startTime: Math.round(startTime - data.result.startTime),
                duration: Math.round(duration),
                workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
                fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
                type: initiatorType,
                ...$afe2468bddae52b1$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
            };
        });
        return {
            'timings:resource': resourceTiming
        };
    };
});
parcelRegister("8TkSE", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$54bbd0e7cc722e21$export$bea963256235a63e);
    $parcel$export(module.exports, "getResourceTimings", ()=>$54bbd0e7cc722e21$export$9eebb59359c2e9e5);
    var $2T3fn;
    var $6f44G;
    const $54bbd0e7cc722e21$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>({
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: Math.round(entry.startTime),
                duration: Math.round(entry.duration),
                fetchStart: Math.round(entry.fetchStart || 0),
                workerStart: Math.round(entry.workerStart || 0),
                responseStart: Math.round(entry.responseStart || 0)
            }),
        start: (performance = (0, (0, parcelRequire("6f44G")).getPerformanceObject)(), PerformanceObserver1 = (0, (0, parcelRequire("6f44G")).getPerformanceObserverObject)())=>{
            if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
            if ($54bbd0e7cc722e21$export$bea963256235a63e.observer) {
                (0, (0, parcelRequire("2T3fn")).ufologger).warn('Observer is already running');
                return;
            }
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $54bbd0e7cc722e21$export$bea963256235a63e.timings = resources.map((resource)=>$54bbd0e7cc722e21$export$bea963256235a63e.transformResource(resource));
            $54bbd0e7cc722e21$export$bea963256235a63e.observer = new PerformanceObserver1($54bbd0e7cc722e21$export$bea963256235a63e.addTimings);
            $54bbd0e7cc722e21$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($54bbd0e7cc722e21$export$bea963256235a63e.observer) {
                $54bbd0e7cc722e21$export$bea963256235a63e.observer.disconnect();
                $54bbd0e7cc722e21$export$bea963256235a63e.observer = null;
            }
            $54bbd0e7cc722e21$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$54bbd0e7cc722e21$export$bea963256235a63e.transformResource(entry));
            const overflow = $54bbd0e7cc722e21$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $54bbd0e7cc722e21$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $54bbd0e7cc722e21$export$bea963256235a63e.maxSize;
                $54bbd0e7cc722e21$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $54bbd0e7cc722e21$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $54bbd0e7cc722e21$export$9eebb59359c2e9e5 = (startTime, performance = (0, (0, parcelRequire("6f44G")).getPerformanceObject)())=>{
        if (!PerformanceObserver || !$54bbd0e7cc722e21$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
            return null;
        }
        return $54bbd0e7cc722e21$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
    };
});
parcelRegister("dS1TE", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleState", ()=>$538b7af3b4842588$export$723b4c298aca63af);
    var $dYd4e;
    const $538b7af3b4842588$export$723b4c298aca63af = (data)=>{
        return {
            'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, (0, parcelRequire("dYd4e")).PageVisibleState).HIDDEN : (0, (0, parcelRequire("dYd4e")).PageVisibleState).VISIBLE)
        };
    };
});
parcelRegister("2psna", function(module, exports) {
    $parcel$export(module.exports, "appFramework", ()=>$8d9bd06d810fb74c$export$e34e4529b979f74c);
    const $8d9bd06d810fb74c$export$e34e4529b979f74c = (config)=>{
        if (!config.framework) return null;
        return {
            'app:framework:name': config.framework.name,
            'app:framework:version': config.framework.version
        };
    };
});
parcelRegister("ilFjQ", function(module, exports) {
    $parcel$export(module.exports, "appVersion", ()=>$6734cfa9293b172f$export$82ae485178b37419);
    const $6734cfa9293b172f$export$82ae485178b37419 = (config)=>{
        const pluginData = {
            'app:web:version': config.version.web
        };
        if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
        return pluginData;
    };
});
parcelRegister("cUX8Z", function(module, exports) {
    $parcel$export(module.exports, "eventBrowserPlugin", ()=>$48bc764237abbbbd$export$f435c2789ca334a7);
    var $4XKM3 = parcelRequire("4XKM3");
    var $8QpSo;
    var $6f44G;
    const $48bc764237abbbbd$export$f435c2789ca334a7 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!(0, ($parcel$interopDefault($4XKM3))).getParser) return null;
        const browser = (0, ($parcel$interopDefault($4XKM3))).getParser((0, (0, parcelRequire("6f44G")).getWindowObject)()?.navigator?.userAgent || '');
        return {
            'event:browser:name': browser.getBrowserName(),
            'event:browser:version': browser.getBrowserVersion()
        };
    });
});
parcelRegister("esDQp", function(module, exports) {
    $parcel$export(module.exports, "eventCpusPlugin", ()=>$7de6d5caaac01243$export$db7649b8854107ad);
    var $8QpSo;
    const $7de6d5caaac01243$export$db7649b8854107ad = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!navigator.hardwareConcurrency) return null;
        return {
            'event:cpus': navigator.hardwareConcurrency
        };
    });
});
parcelRegister("b1Utc", function(module, exports) {
    $parcel$export(module.exports, "featureFlags", ()=>$ee2bfd49c5949b75$export$e62953d023125748);
    const $ee2bfd49c5949b75$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
        const allFeatureFlags = [
            ...featureFlags,
            ...data.featureFlags || []
        ];
        if (allFeatureFlags.length === 0) return null;
        const initialMemo = [];
        allFeatureFlags.reduce((memo, featureFlagKey)=>{
            const ffVal = featureFlagClient.getValue(featureFlagKey);
            if (ffVal !== undefined && ffVal !== null) memo.push([
                featureFlagKey,
                ffVal
            ]);
            return memo;
        }, initialMemo);
        const mappedFeatureFlags = Object.fromEntries(initialMemo);
        return {
            featureFlags: mappedFeatureFlags
        };
    };
});
parcelRegister("8SgNH", function(module, exports) {
    $parcel$export(module.exports, "eventMemoryPlugin", ()=>$d7c1d1979c44d7be$export$81efaf8414879a1a);
    var $8QpSo;
    const $d7c1d1979c44d7be$export$81efaf8414879a1a = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (!navigator.deviceMemory) return null;
        return {
            'event:memory': navigator.deviceMemory
        };
    });
});
parcelRegister("gZjV8", function(module, exports) {
    $parcel$export(module.exports, "eventNetworkPlugin", ()=>$c0759ba3f98376e3$export$ce1cf816dce1da56);
    const $c0759ba3f98376e3$export$ce1cf816dce1da56 = ()=>{
        if (!navigator.connection) return null;
        return {
            'event:network:effectiveType': navigator.connection.effectiveType,
            'event:network:rtt': navigator.connection.rtt,
            'event:network:downlink': navigator.connection.downlink
        };
    };
});
parcelRegister("bIXdx", function(module, exports) {
    $parcel$export(module.exports, "ssrFeatureFlags", ()=>$5e999628a2a9c6be$export$fdbea518c19dfa8);
    const $5e999628a2a9c6be$export$fdbea518c19dfa8 = (ssr)=>{
        if (!ssr?.getFeatureFlags) return null;
        try {
            const featureFlags = ssr.getFeatureFlags();
            if (featureFlags) return {
                'ssr:featureFlags': featureFlags
            };
        } catch (e) {}
        return null;
    };
});
parcelRegister("7drP3", function(module, exports) {
    $parcel$export(module.exports, "ssrSuccess", ()=>$82fdf29c8adcdba5$export$a3dc8251cf55b2e0);
    const $82fdf29c8adcdba5$export$a3dc8251cf55b2e0 = (ssr)=>{
        if (ssr?.getDoneMark()) return {
            'ssr:success': true
        };
        return null;
    };
});
parcelRegister("9FL2N", function(module, exports) {
    $parcel$export(module.exports, "Route", ()=>$74f4330307555eaf$export$e7b0ac011bb776c6);
    const $74f4330307555eaf$export$e7b0ac011bb776c6 = {
        route: '',
        setRoute (newRoute) {
            this.route = newRoute;
        },
        getRoute () {
            return this.route;
        }
    };
});
const $0ec629ff645fb0d9$export$70df29c238ba7306 = 'mediaCtx';
const $ddc5ba965a26499f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $ddc5ba965a26499f$export$f005e2e9f707cb5f = 'commercial';
const $ddc5ba965a26499f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $ddc5ba965a26499f$export$a739cd5aac835909 = 'stg';
const $ddc5ba965a26499f$export$42dd0cdd351a4a9 = 'prod';
const $ddc5ba965a26499f$export$404582bc18fe4d9e = 'dev';
const $240e7c27c4097a0a$export$42f4885608027d0c = 'non_boolean';
const $671c304dce8903bc$export$b98e411ae80c806f = '/';
const $835d34a7c9fd1af2$export$cf090d5281b5ae06 = 10000;
const $835d34a7c9fd1af2$export$8575e30be0feb909 = 30000;
const $a428e064f91eae50$export$a1562d08625f5d7e = 'ui';
const $a428e064f91eae50$export$947dac6c72b26f81 = 'track';
const $a428e064f91eae50$export$f1d537d508d2945a = 'screen';
const $a428e064f91eae50$export$12346a674644c156 = 'operational';
const $a428e064f91eae50$export$b055de0e665cb20c = 'unknown';
const $ac85ba4533d29a9f$export$3288b14b6745c572 = 204;
const $ac85ba4533d29a9f$export$c09e7ea0fc79f34f = 409;
const $ac85ba4533d29a9f$export$974c37534b0191b1 = 503;
$parcel$global.rlb("i5RRW");
